import { Skeleton } from "../components/ui/skeleton";
import { AudioPlayer, DownloadIcon, ExpandIcon, FavoritesIcon, LeftArrowIcon, LinkIcon, MiniMize, PlayIcon, PrintIcon, VoiceSquare } from "../components";
import { Link } from "react-router-dom";
import useCopyToClipboard from "../hooks/useCopyToClipboard";
import React, { useState, useRef, useEffect , forwardRef } from "react";

const HtmlRenderer = ({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

const CCSacredMusic =  forwardRef((Content , ref)=> {
  // const data = Content.data;
  // const loading = Content.loading;
  // const handleToggleFavorite = Content.handleToggleFavorite;
  // const handlePrint = handlePrint
  const {
    data,
    loading,
    handleToggleFavorite,
    handlePrint,
    printTopRef,
    printBottomRef,
    printMidRef,
  } = Content


  // Toggle popup function
  const togglePopup = () => {
    if (isPopupVisible) {
      setIsClosing(true);
      setTimeout(() => {
        setIsPopupVisible(false);
        setIsClosing(false);
      }, 300);
    } else {
      setIsPopupVisible(true);
    }
  };

  const { copied, copyToClipboard } = useCopyToClipboard();
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);


    const [isChecked, setIsChecked] = useState(false);
  
    const [activePlayerIndex, setActivePlayerIndex] = useState(null); // Track active audio player
    const [progress, setProgress] = useState(0);
    const audioRef = useRef(null);
    const [progressPercentage, setProgressPercentage] = useState(0);
  
    
    // Handle play button click
    const handlePlayClick = (index) => {
      if (activePlayerIndex === index) {
        setActivePlayerIndex(null); // Stop current player
        if (audioRef.current) {
          audioRef.current.pause(); // Pause the audio
        }
      } else {
        setActivePlayerIndex(index); // Activate the selected player
        setTimeout(() => {
          if (audioRef.current) {
            audioRef.current.play(); // Start playing the audio
          }
        }, 0); // Ensure state updates before playback
      }
    };
  
    // Handle closing the player
    const handleCloseAudioPlayer = () => {
      setActivePlayerIndex(null); // Close the player
      if (audioRef.current) {
        audioRef.current.pause(); // Pause the audio
      }
    };
  
    const handleProgressUpdate = (progress) => {
      setProgressPercentage(progress);
    };
  

  const audioData = [
    {
      title: "Play English",
      src: "http://webaudioapi.com/samples/audio-tag/chrono.mp3",
      excerpt: "English Language Audio",
    },
    {
      title: "Play Latin",
      src: "https://jervo.org/zanado/audio/halo.mp3",
      excerpt: "Latin Language Audio",
    },
  ];

  return (
    <div className="h-full" ref={ref}>
      <div className="flex flex-col h-full px-8 lg:px-0 lg:pr-8 lg:flex-row">
        {/* Left Sidebar */}
        <div className="w-full h-auto border-b border-gray-100 lg:w-1/3 lg:border-r lg:border-b-0">
          <div className="flex justify-between px-4 py-8 lg:px-6 lg:pl-14">
            <Link
              className="flex items-center gap-3 group"
              to="/culture-and-customs"
            >
              <div className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 print:hidden">
                <LeftArrowIcon className="text-gray-700 group-hover:text-gold-500" />
              </div>
              <h5 className="print:hidden text-base text-gray-600 group-hover:text-gold-500">
                Back to Culture & Customs
              </h5>
            </Link>
          </div>
          <div className="px-4 lg:pl-12 pb-8">
            {data.imageUrl && 
              <div ref={printTopRef} className="relative w-full object-cover rounded-3xl">
                <img
                  className="object-cover w-full h-full rounded-3xl max-h-44 mb-8"
                  src={data.imageUrl}
                  alt={data.title}
                />
                {/* Expand Icon for Popup */}
                <div
                  className="absolute flex items-center justify-center transition rounded-full cursor-pointer bottom-4 right-4 h-11 w-11 bg-grayTransparent hover:scale-110"
                  onClick={togglePopup}
                >
                  <ExpandIcon className="text-white" />
                </div>
              </div>
            }
            
            <h2 className="text-2xl font-bold text-gray-900 pb-0.5">
              {data.title}
            </h2>
            <div className="flex flex-row flex-wrap gap-2 mt-3">
              {loading ? (
                <Skeleton className="w-1/3 h-4 rounded" />
              ) : (
                data?.categories &&
                data.categories.map((category, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 text-xs bg-gold-50 text-gold-500 rounded-xl"
                  >
                    {category}
                  </span>
                ))
              )}
              {/* CatList (Seasons and Nationalities) */}
              {data?.catList &&
                data.catList.map((cat, index) => (
                  <span
                    key={`cat-${index}`}
                    className="px-2 py-1 text-xs font-medium leading-4 bg-gold-50 text-gold-500 rounded-27"
                  >
                    {cat}
                  </span>
                ))}
            </div>

            {data?.description && (
              <div ref={printMidRef} className="mt-3">
                <div
                  className="text-gray-700 text-base"
                  dangerouslySetInnerHTML={{
                    __html: `<p>${
                      data.description
                        .replace(/<\/p>\s*<p[^>]*>/g, " ") // Merge multiple <p> tags
                        .replace(/<\/?p[^>]*>/g, "") // Remove remaining <p> tags
                        .replace(/<br\s*\/?>/gi, " ") // Remove <br> tags
                        .replace(/(\.\.\.|&hellip;)?\s*Read\s*more.*$/i, '')
                        .trim() || "No Description Available"
                    }</p>`,
                  }}
                />
              </div>
            )}
            {/* <p className="text-gray-800">{data.description}</p> */}
          </div>
          
          {audioData && 
            <div className="px-4 lg:pl-12 pb-8">
              {audioData.map((audio, index) => (
                  <div
                    key={index}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default link behavior
                      handlePlayClick(index); // Play or pause based on the current state
                    }}
                    className="cursor-pointer w-full bg-gold-300 rounded-[50px] p-2 flex items-center justify-between mb-3 last:mb-0"
                  >
                    {/* Play/Pause Button */}
                    <div className="flex items-center justify-center rounded-full bg-gold-200 md:h-11 md:w-11 h-9 w-9">
                      {activePlayerIndex === index ? (
                        <VoiceSquare progress={progressPercentage / 100}  />
                      ) : (
                        <PlayIcon className="text-gray-0" />
                      )}
                    </div>

                    {/* Audio Title */}
                    <div className="flex items-center justify-center flex-grow select-none">
                      <p className="text-lg font-bold text-gray-0">{audio.title}</p>
                    </div>
                  </div>
              ))}
            </div>
          }

          <div ref={printBottomRef} className="border-t-1 border-gray-100 pt-8">
            <div className="px-4 lg:pl-12">
              <h5 className="mb-3 text-base font-semibold leading-5 text-gray-900">
                Author:
              </h5>
              <div className="flex flex-row items-center gap-2 mb-8">
                <img src="/favicon.png" alt="Favicon" className="w-7 h-7" />
                <p className="font-medium text-sm leading-4.5 text-gray-700">
                  {data?.author}
                </p>
              </div>
            </div>

            {data?.ps_source_attribution && 
              <div className="px-4 lg:pl-12 mb-8">
                <h5 className="mb-3 text-base font-semibold leading-5 text-gray-900">
                Source:
                </h5>
                <div className="rounded-xl bg-gold-50 p-4 text-base leading-5 text-gray-900">
                  {data?.ps_source_attribution}
                </div>
              </div>
            }
          </div>
        </div>

        {/* Right Image Section */}
        <div className="w-full h-auto px-4 pt-8 pb-8 lg:w-2/3 lg:pt-0 xl:px-12">
          <div className="justify-end hidden gap-2 pt-8 pb-8 lg:flex">
            {loading || !data ? (
              <Skeleton className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group" />
            ) : (
              <button
                key={data.favorite} //  Forces re-render when favorite state changes
                type="button"
                onClick={(e) => handleToggleFavorite(e, data.id)}
                className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group"
              >
                <FavoritesIcon
                  filled={Boolean(data?.favorite)}
                  className={`w-7 h-7 transition-colors duration-200 ${
                    data?.favorite
                      ? "text-red-500"
                      : "text-gray-500 hover:text-red-500"
                  }`}
                />
              </button>
            )}
            <a
              href="#"
              className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group"
            >
              <DownloadIcon className="text-gray-700 w-7 h-7 group-hover:text-gold-500" />
            </a>
            <button
              type="button"
              onClick={handlePrint} // <- must be passed from parent
              className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group"
            >
              <PrintIcon className="text-gray-700 w-7 h-7 group-hover:text-gold-500" />
            </button>
            <a
              href="#"
              className="flex items-center justify-center rounded-full bg-gold-50 h-11 w-11 group"
              onClick={(e) => {
                e.preventDefault(); // Prevent navigation
                copyToClipboard();
              }}
            >
              <LinkIcon
                className={`text-gray-700 w-7 h-7 group-hover:text-gold-500 ${copied ? "text-green-500 group-hover:text-green-500" : ""}`}
              />
            </a>
          </div>
          <div
            className="text-gray-700 text-lg"
            dangerouslySetInnerHTML={{
              __html: `<p>${(data.about || "No Description Available")
                .replace(/<\/p>\s*<p[^>]*>/g, " ") // Merge content between <p> tags
                .replace(/<\/?p[^>]*>/g, "") // Remove all remaining <p> tags
                .replace(/<br\s*\/?>/gi, " ") // Remove <br> or <br /> tags
                .trim()}</p>`,
            }}
          />
          
        </div>
      </div>

      {/* Fullscreen Popup */}
      {isPopupVisible && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-70"
          onMouseDown={togglePopup}
        >
          <div
            className={`relative max-w-[1040px] max-h-[616px] w-full h-full ${
              isClosing ? "animate-popupZoomIn" : "animate-popupZoomOut"
            }`}
          >
            <img
              className="object-cover w-full h-full rounded-3xl"
              src={data.imageUrl}
              alt={data.title}
            />
            {/* Minimize Button */}
            <button
              className="absolute flex items-center justify-center transition rounded-full bottom-4 right-4 h-11 w-11 bg-grayTransparent hover:scale-90"
              onClick={togglePopup}
            >
              <MiniMize className="text-white" />
            </button>
          </div>
        </div>
      )}
      <div className='fixed bottom-0 xl:left-[16.66%] md:left-[15rem] left-0 right-0 z-50'>

        {/* Conditionally render AudioPlayer with animation */}
        <div
          className={`transition-transform duration-500 ease-out transform bg-gray-0 ${activePlayerIndex !== null ? "animate-slideUp" : "animate-slideDown"
            }`}
        >
          {activePlayerIndex !== null && (
            <AudioPlayer
              src={audioData[activePlayerIndex].src}
              title={audioData[activePlayerIndex].title}
              excerpt={audioData[activePlayerIndex].excerpt}
              onClose={handleCloseAudioPlayer}
              audioRef={audioRef}
              onProgressUpdate={handleProgressUpdate}
              // Pass the ref to control audio
            />
          )}
        </div>

      </div>
    </div>

  );
})
export default CCSacredMusic;